// extracted by mini-css-extract-plugin
module.exports = {"content":"Body_content__Mn_Xw","title":"Body_title__swSA0","subtitle":"Body_subtitle__h2Ojv"};